'use client';

import Image from 'next/image';
import { ComponentProps, useEffect, useState } from 'react';
import { cn } from '@/lib/ui-kit/utils';

type UiImageProps = {
  size: 'sm' | 'md' | 'lg' | number;
  round?: boolean;
  alt: string;
  src: string;
  fallback?: string;
} & ComponentProps<'div'>;

const sizes = {
  ['sm']: 36,
  ['md']: 44,
  ['lg']: 56,
};

export function UiImage({
  alt,
  src,
  size = 'md',
  round = false,
  className,
  fallback = '/events/event_1.png',
  ...props
}: UiImageProps) {
  const [imgSrc, setImgSrc] = useState(src);
  useEffect(() => setImgSrc(src), [src]);
  const pxSize: number = typeof size === 'number' ? size : sizes[size];

  return (
    <div
      className={cn(
        'bg-background shrink-0 overflow-hidden rounded-[8px]',
        {
          'rounded-md': !round,
          'rounded-[8px]': round,
        },
        className,
      )}
      style={{ width: pxSize, height: pxSize }}
      {...props}
    >
      <Image
        loading={'eager'}
        width={pxSize}
        height={pxSize}
        sizes={`${pxSize}px`}
        className="h-full max-h-full w-full max-w-full object-cover"
        style={{
          objectFit: 'cover',
        }}
        src={imgSrc}
        alt={alt}
        onError={() => setImgSrc(fallback)}
      />
    </div>
  );
}
